import React from 'react'
import { Switch, Route } from 'react-router-dom'

import Loadable from 'src/utils/loadable'

const routes = () => {
  return (
    <Switch>
      {/* Same path is used for "Login as Kiosk user" (from Pathway side) and for login from email token */}
      <Route
        path='/auth/email/:token/:ref?/:redirectTo?'
        component={Loadable(() => import('./EmailVerification'))}
      />
      <Route path='/auth/login' component={Loadable(() => import('./Email'))} />
      <Route path='/auth/profile' component={Loadable(() => import('./Auth'))} />
    </Switch>
  )
}

export default routes
